import { useId } from 'react';

import { Icon } from '@/shared/types/icon';

export const Anthropic = ({ size = 24, ...rest }: Icon) => {
  const id = useId();
  const clipId = `anthropic-clip-${id}`;

  return (
    <svg
      viewBox="0 0 28 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M19.638 -6.48499e-05H15.4708L23.07 19.1999H27.2372L19.638 -6.48499e-05Z"
          fill="black"
        />
        <path
          d="M7.59918 0L0 19.2H4.249L5.80316 15.168H13.7531L15.3073 19.2H19.5563L11.9571 0H7.59918ZM7.17754 11.6023L9.77816 4.85486L12.3788 11.6023H7.17754Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="28" height="19.2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
